import React from 'react';
import AppCommon from '@nocode/common';

function App() {
  console.log("===version===", 2);
  return <AppCommon />;
}

export default App;
